import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import bs from '../../../bsApp';
import RemaksIcon from '../RemaksIcon';
import { classNames } from '../../../../../utils';
import { ReactComponent as Frozen } from '../../../../../static/images/icon_Frozen.svg';
import { ReactComponent as OccpuiedGirl } from '../../../../../static/images/icon_Occpuied_Girl.svg';
import { ReactComponent as OccpuiedBoy } from '../../../../../static/images/icon_Occpuied_Boy.svg';

const styles = makeStyles((thmem) => ({
  rectIcon: {
    width: '1.25rem',
    height: '0.938rem',
    borderRadius: '0.281rem',
  },
}));

export default function BottonStatusIcon({ typeName, className }) {
  const classes = styles();
  const classesName = classNames(classes.rectIcon, className);

  switch (typeName) {
    case bs.AVAILABLE:
      return <div className={classesName} style={{ background: '#cff5ec' }} />;
    case bs.OCCUPIED:
      return (
        <Box display="flex" className={className}>
          <OccpuiedGirl style={{ marginRight: '0.313rem' }} />
          <OccpuiedBoy />
        </Box>
      );
    case bs.DISCHARGING:
      return <RemaksIcon typeName={bs.DISCHARGING} className={className} />;
    case bs.TBC:
      return <div className={classesName} style={{ background: '#fff', border: 'solid 2px #bec3d4' }} />;
    case bs.UNAVAILABLE:
      return <div className={classesName} style={{ background: '#e2e4ec' }} />;
    case bs.MISSING:
      return <div className={classesName} style={{ background: '#fff1ae' }} />;
    case bs.MISSING_CLOSED:
      return <div className={classesName} style={{ background: '#ffdb88' }} />;
    case bs.FROZEN:
      return <Frozen />;
    default:
      return <div />;
  }
}
